import {
  CSV_EXPORT_START_INPROGRESS,
  CSV_EXPORT_START_DONE,
  CSV_EXPORT_START_ERROR
} from '../constants/constant_saga_types';

const INIT_STATE = {
  exporting: false,
  error: {
    isError: false,
    message: ''
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CSV_EXPORT_START_INPROGRESS: {
      const { exporting } = action.payload;
      return { ...INIT_STATE, exporting };
    }

    case CSV_EXPORT_START_DONE: {
      return { ...INIT_STATE };
    }

    case CSV_EXPORT_START_ERROR: {
      const { error } = action.payload;
      return { ...INIT_STATE, error: { ...error } };
    }

    default: {
      return state;
    }
  }
};
